import type { ReportSubscription } from '@common/types';

import { PROPERTIES } from './group-scope.seed';

const TEMPLATES: ReadonlyArray<Omit<ReportSubscription, 'id' | 'accountId'>> = [
  {
    reportId: 'report-comprehensive',
    reportName: 'Comprehensive Performance',
    cadence: 'monthly',
    format: 'pdf',
    recipientLabels: ['General Manager', 'Group Insights'],
    nextRunIso: '2026-09-01T06:00:00.000Z',
    lastRunIso: '2026-08-01T06:00:00.000Z',
    lastRunStatus: 'sent',
    isEnabled: true,
  },
  {
    reportId: 'report-service-rating',
    reportName: 'Service Rating Breakdown',
    cadence: 'weekly',
    format: 'pdf',
    recipientLabels: ['Heads of Department'],
    nextRunIso: '2026-09-01T05:00:00.000Z',
    lastRunIso: '2026-08-25T05:00:00.000Z',
    lastRunStatus: 'sent',
    isEnabled: true,
  },
  {
    reportId: 'report-review-source',
    reportName: 'Review Source Mix',
    cadence: 'monthly',
    format: 'csv',
    recipientLabels: ['marketing@suninternational.com'],
    nextRunIso: '2026-09-01T06:30:00.000Z',
    lastRunIso: '2026-08-01T06:30:00.000Z',
    lastRunStatus: 'failed',
    isEnabled: true,
  },
  {
    reportId: 'report-competitor',
    reportName: 'Competitor Positioning',
    cadence: 'quarterly',
    format: 'pdf',
    recipientLabels: ['Executive Committee'],
    nextRunIso: '2026-10-01T06:00:00.000Z',
    lastRunIso: '2026-07-01T06:00:00.000Z',
    lastRunStatus: 'sent',
    isEnabled: false,
  },
];

function buildSubscriptions(): ReportSubscription[] {
  return PROPERTIES.flatMap((property, index) =>
    TEMPLATES.slice(0, 2 + (index % 3)).map((template, i) => ({
      ...template,
      id: `${property.id}-sub-${i + 1}`,
      accountId: property.id,
    })),
  );
}

export const REPORT_SUBSCRIPTIONS_SEED: ReadonlyArray<ReportSubscription> = buildSubscriptions();
